const LoadingSkeleton = () => (
  <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
    {/* Header skeleton */}
    <div className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm border-b border-gray-200">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="h-8 w-32 bg-gray-200 rounded animate-pulse" />
        <div className="flex gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
          ))}
        </div>
      </div>
    </div>

    {/* Hero skeleton */}
    <div className="pt-16 container mx-auto px-4">
      <div className="min-h-[500px] flex flex-col justify-center items-center text-center space-y-6 py-20">
        <div className="h-12 w-96 max-w-full bg-gray-200 rounded animate-pulse" />
        <div className="h-6 w-80 max-w-full bg-gray-200 rounded animate-pulse" />
        <div className="h-12 w-40 bg-gray-200 rounded animate-pulse mt-4" />
      </div>

      {/* Content skeleton */}
      <div className="space-y-8 pb-20">
        {[1, 2, 3].map((i) => (
          <div key={i} className="space-y-4">
            <div className="h-8 w-64 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-4/6 bg-gray-200 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>

    {/* Footer skeleton */}
    <div className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map((i) => (
          <div key={i} className="space-y-4">
            <div className="h-6 w-32 bg-gray-700 rounded animate-pulse" />
            <div className="h-4 w-48 bg-gray-700 rounded animate-pulse" />
            <div className="h-4 w-40 bg-gray-700 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default LoadingSkeleton;
